import { FC } from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../../../../common/store';
import SeenIcon from '../../../../../../static/assets/read-receipts/seen-icon'
import SentIcon from '../../../../../../static/assets/read-receipts/sent-icon';
import SendingIcon from '../../../../../../static/assets/read-receipts/sending-icon';
import DeliveredIcon from '../../../../../../static/assets/read-receipts/delivered-icon';
interface UserChatMessageTimestampProps {
  timestamp: string;
  actor: string; // 'U' | 'A' | 'live_agent' | others (ignored)
  messageStatus: 'sending' | 'sent' | 'delivered' | 'seen' | null;
}
export const UserChatMessageTimestamp: FC<UserChatMessageTimestampProps> = ({
  timestamp,
  actor,
  messageStatus
}) => {
  const isChattingWithLiveAgent = useAppSelector(
    (state) => state.chat.isChattingWithLiveAgent
  );
  // Only render if actor is recognized
  if (!['U', 'A', 'live_agent'].includes(actor)) return null;

  return (
    <UserChatMessageTimestampContainer actor={actor}>
      {timestamp}
      {messageStatus !== null &&
      (messageStatus === 'sending' ? (
        <SendingIcon/>
      ) : messageStatus === 'sent' ? (
        <SentIcon />
      ) : messageStatus === 'delivered' ? (
        <DeliveredIcon />
      ) : messageStatus === 'seen' ? (
        <SeenIcon />
) : null)}
    </UserChatMessageTimestampContainer>
  );
};

const UserChatMessageTimestampContainer = styled.div<{ actor: string }>`
  display: flex;
  align-items: center;
  justify-content: ${({ actor }) => (actor === 'U' ? 'flex-end' : 'flex-start')};
  width: 100%;
  gap: 0.25rem;
  font-size: 0.75rem;
  color: #6B7280; 
  padding-left: 0.5rem;
`;

